import React from 'react';
import Image1 from '../images/aboutUs1.webp';
import Image2 from '../images/aboutUs2.webp';
import Image3 from '../images/aboutUs3.webp';
import { FaLeaf, FaCertificate, FaUsers } from 'react-icons/fa'; // Icons for extra visual appeal

const AboutUs = () => {
  return (
    <div className="about-us">


      <div className="about-container">
        <h2>About Us</h2>

        {/* Brand Story Section */}
        <section className="brand-story">
          <h3>Our Story</h3>
          <p>
            We are a skincare and haircare brand
            committed to delivering natural, effective, and
            eco-friendly products that align with modern
            wellness and sustainability values. Born out of
            a passion for creating clean and conscious
            beauty solutions, our mission is to offer safe,
            high-quality products that cater to your
            everyday self-care needs—without
            compromising the health of your skin, hair, or
            the planet.
            At the heart of our brand lies a dedication to
            transparency, integrity, and environmental
            responsibility. Each product is thoughtfully
            formulated using plant-based, cruelty-free
            ingredients sourced from nature, with a
            strong emphasis on avoiding harmful
            chemicals, synthetic fragrances, and artificial
            additives. We believe beauty should be kind—
            to your body, your routine, and the Earth.
            Our collections are designed to nourish and
            rejuvenate, supporting holistic well-being
            while addressing common concerns like
            dryness, sensitivity, hair fall, and
            environmental stressors. every aspect of our
            brand is crafted to minimize environmental
            impact while maximizing benefits for our
            customers.
            We invite you to experience skincare and
            haircare that’s rooted in nature, backed by
            science, and inspired by a vision of a cleaner,
            greener future.
          </p>
        </section>

        {/* Mission & Vision */}
        <section className="mission-vision">
          <div className="mission">
            <FaLeaf size={40} color="#2e7d32" />
            <h4>Our Mission</h4>
            <p>Our mission is to deliver skincare and haircare products that are kind to your body and the environment. We aim to make beauty routines simple, effective, and nourishing through the power of nature.</p>
          </div>
          <div className="vision">
            <FaCertificate size={40} color="#2e7d32" />
            <h4>Our Vision</h4>
            <p>We envision a world where everyone has access to natural beauty solutions that promote health, sustainability, and ethical practices. Our vision is to be a trusted brand for anyone seeking pure, high-quality products.</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="product-benefits">
          <h3>Why Choose Our Products?</h3>
          <div className="benefits">
            <div className="benefit">
              <img src={Image1} alt="Ingrediants Image" />
              <h4>100% Natural Ingredients</h4>
              <p>Our products are made with the finest natural ingredients to ensure maximum nourishment and care for your skin and hair.</p>
            </div>
            <div className="benefit">
              <img src={Image2} alt="Ingrediants Image" />
              <h4>Gentle & Effective</h4>
              <p>Each product is carefully crafted to be gentle on your skin and hair while providing effective results.</p>
            </div>
            <div className="benefit">
              <img src={Image3} alt="Ingrediants Image" />
              <h4>Eco-Friendly</h4>
              <p>We prioritize sustainability in every aspect of our business, from packaging to ingredients. Our products are cruelty-free and eco-conscious.</p>
            </div>
          </div>
        </section>

        {/* Social Proof Section */}
        <section className="social-proof">
          <div className="award">
            <FaUsers size={40} color="#2e7d32" />
            <h4>Trusted by Thousands</h4>
            <p>We have a growing community of loyal customers who trust our products for their daily skincare and haircare needs.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
